/** Logo assets for collections landing integrations (`public/integrations/`). */
export const COLLECTIONS_INTEGRATION_LOGOS: Record<string, string | string[]> = {
  Finvi: "/integrations/finvi.svg",
  "Latitude by Genesys": "/integrations/latitude.webp",
  "DAKCS Beyond": "/integrations/dacks.webp",
  Salesforce: "/integrations/salesforce.webp",
  QuickBooks: "/integrations/quickbooks.webp",
  NetSuite: "/integrations/netsuite.webp",
  "Stripe · Repay": "/integrations/stripe.webp",
  "Bureau APIs": [
    "/integrations/equifax.webp",
    "/integrations/expedian.webp",
    "/integrations/td.webp",
  ],
};

export function getCollectionsIntegrationLogos(name: string): string[] {
  const logo = COLLECTIONS_INTEGRATION_LOGOS[name];
  if (!logo) {
    return [];
  }
  return Array.isArray(logo) ? logo : [logo];
}
